const storage = sessionStorage;

function sessionStorageSetItem(key, value, isAlreadyString = true) {

    try {
        if (isAlreadyString) {
            storage.setItem(key, value);
        } else {
            storage.setItem(key, JSON.stringify(value));
        }
    } catch (error) {
        return null
    }

}

function sessionStorageGetItem(key, valueToBeReturnAsString = true) {

    try {
        const storedItem = storage.getItem(key);
        if (valueToBeReturnAsString) {
            return storedItem ? storedItem : null;
        } else {
            return storedItem ? JSON.parse(storedItem) : null;
        }
    } catch (error) {
        return null;
    }

}


function sessionStorageRemoveItem(key) {

    try {
        storage.removeItem(key);
    } catch (error) {
        return null
    }

}


function sessionStorageClearAll() {

    try {
        storage.clear();
    } catch (error) {
        return null
    }

}

export { sessionStorageSetItem, sessionStorageGetItem, sessionStorageRemoveItem, sessionStorageClearAll }
